import { InputHTMLAttributes } from 'react';

import { mask as inputMask } from '../../utils/mask';

import { InputContainer } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  mask?: string;
  isNumber?: boolean;
}

function Input({ label, name, isNumber, mask, ...rest }: InputProps) {
  const id = name + Date.now();
  
  function handleFocus(event: React.FocusEvent<HTMLInputElement>) {
    if (isNumber) event.target.placeholder = 'Ex: (71) 98877-6655';
  }

  function handleBlur(event: React.FocusEvent<HTMLInputElement>) {
    if (isNumber) event.target.placeholder = '';
  }

  return (
    <InputContainer className="input">
      <input 
        type="text" 
        id={id} 
        name={name} 
        required 
        autoComplete="off"
        onFocus={(event) => handleFocus(event)}
        onBlur={(event) => handleBlur(event)}
        onKeyUp={mask ? (event) => inputMask(mask, event) : () => {}}
        { ...rest } 
      />

      <label htmlFor={id}>
        {label}
      </label>
    </InputContainer>
  );
};

export default Input;